// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3xsqY","buttons":"SendReceipts_buttons__3_Uvm","email":"SendReceipts_email__2USI0","bookApptTitle":"SendReceipts_bookApptTitle__ayB46"};